export var getCookie = function (name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === name + '=') {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
};
export var setCookie = function (name, value, expires, path, domain, secure) {
    if (value === null) {
        value = '';
        expires = -1;
    }
    if (expires && (typeof expires === 'number' || expires.toUTCString)) {
        var date = void 0;
        if (typeof expires === 'number') {
            date = new Date();
            date.setTime(date.getTime() + expires * 1000);
        }
        else {
            date = expires;
        }
        expires = ';expires=' + date.toUTCString();
    }
    path = path ? ';path=' + path : '';
    domain = domain ? ';domain=' + domain : '';
    secure = secure ? ';secure' : '';
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
};
export var numberFormat = function (num) {
    if (num === undefined || num === '' || num === null)
        return num;
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var itemThumbUrl = function (itemId, size) {
    if (size === void 0) { size = 500; }
    if (!itemId) {
        console.error('item id error');
    }
    var trans = Math.ceil(parseInt(itemId.toString(), 10) / 1000) * 1000;
    var imgSrc = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_").concat(trans, "/img_").concat(itemId, "/").concat(size, ".jpg");
    return imgSrc;
};
export var Offset = function (selector) {
    var dqs = document.querySelector(selector);
    try {
        var rect = dqs.getBoundingClientRect();
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var offset = {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
            width: rect.width,
            height: rect.height,
        };
        return offset;
    }
    catch (e) {
        return { top: 0, left: 0, width: 0, height: 0 };
    }
};
export var scrollTo = function (selector, top, behavior) {
    if (behavior === void 0) { behavior = 'smooth'; }
    var select = Offset(selector);
    var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
    var selectTop = top || 0;
    selectTop += select.top;
    var options = {
        behavior: behavior,
        top: selectTop,
        left: 0,
    };
    if (isSmoothScrollSupported) {
        window.scrollTo(options);
    }
    else {
        window.scrollTo(options.left, options.top);
    }
};
export var Estimate = {
    getItems: function () {
        var estString = getCookie('item_est');
        var estArray = estString ? estString.split(',') : [];
        var estFullArray = [];
        var estObj = estArray.map(function (v) {
            var qty = getCookie('cnt_' + v.toString());
            estFullArray.push(v + '|' + qty);
            return { item_id: v, qty: qty };
        });
        return { str: estString, arr: estArray, obj: estObj, fullArr: estFullArray, fullStr: estFullArray.join(',') };
    },
    addItem: function (item_id, val, estItems) {
        if (!estItems)
            estItems = getCookie('item_est');
        var qty = val || 1;
        var estArray = estItems ? estItems.split(',') : [];
        // 동일한 품목 체크후 true + qty / false add
        var checkIdx = estArray.indexOf(item_id.toString());
        if (checkIdx !== -1) {
            var cnt = getCookie('cnt_' + item_id.toString()) || '';
            qty = parseInt(cnt, 10) + qty;
            setCookie('cnt_' + item_id.toString(), qty, (9 * 24 * 60 * 60), '/', ".pping.".concat(process.env.REACT_APP_TLD));
        }
        else {
            estArray.push(item_id);
            setCookie('item_est', estArray.toString(), (9 * 24 * 60 * 60), '/', ".pping.".concat(process.env.REACT_APP_TLD));
            setCookie('cnt_' + item_id.toString(), qty, (9 * 24 * 60 * 60), '/', ".pping.".concat(process.env.REACT_APP_TLD));
        }
        return estArray.toString();
    },
};
export var priceState = function (_a) {
    var price = _a.price, f_sellout = _a.f_sellout, cnt_strock = _a.cnt_strock, seller = _a.seller, isMinishop = _a.isMinishop;
    // 0: 단종 1: 일시품절 2: 가격비교예정 3: 정상
    // f_sellout -> 0 : 판매중, 1 : 품절, 2 : 단종, 11: 강제품절, 12 : 강제단종
    if (f_sellout === 2 || f_sellout === 12) {
        return 0;
    }
    else if (f_sellout === 1 || f_sellout === 11 || price === 0 || (!isMinishop && !seller)) {
        return isMinishop ? 1 : 2;
    }
    else if (isMinishop && !cnt_strock) {
        return 1;
    }
    else {
        return 3;
    }
};
export var dateFomat = function (fullData) {
    if (fullData === undefined)
        return fullData;
    var date = new Date((fullData || "").replace(/-/g, "/").replace(/[TZ]/g, " ").split(".")[0]);
    var diff = (new Date().getTime() - date.getTime()) / 1000; //초
    var dayDiff = Math.floor(diff / 60 / 60 / 24);
    if (diff < 0) {
        return '0초 전';
    }
    else if (diff < 60) {
        return "".concat(Math.floor(diff), "\uCD08 \uC804");
    }
    else if (diff < 3600) {
        return "".concat(Math.floor(diff / 60), "\uBD84 \uC804");
    }
    else if (diff < 86400) {
        return "".concat(Math.floor(diff / 3600), "\uC2DC\uAC04 \uC804");
    }
    else if (diff < 86400 * 8) {
        return "".concat(dayDiff, "\uC77C \uC804");
    }
    var dateSplit = fullData.split(' ')[0];
    var dateFomat = dateSplit.replace(/-/gi, '.');
    return dateFomat;
};
export var inArray = function (hay, needle) {
    return hay.indexOf(needle) === -1;
};



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/util.ts
// module id = 3
// module chunks = 0